import { toast } from 'react-toastify';
import { trackYandexParams, initCarrotQuest } from '../actions/utils';
import { setTimeZone } from '@utils/date';

function updateAllTabs() {
  localStorage.removeItem('shouldUpdate');
  localStorage.setItem('shouldUpdate', true);
}

function user(state = false, action) {
  const newState = { ...state };
  switch (action.type) {
    case 'RECEIVE_COMPLETE_TASKS':
      newState.stats.completeTasks = action.tasks;
      return newState;
    case 'RECEIVE_CURRENT_COURSES':
      newState.courses.current = action.current;
      return newState;
    case 'RECEIVE_TETHER':
      if (action.tether.result) {
        updateAllTabs();
        newState.name = action.tether.name;
      }
      return newState;
    case 'RECEIVE_CONFIRM':
      if (action.result) {
        updateAllTabs();
        newState.confirmed = action.result;
      }
      return newState;
    case 'RECEIVE_SUBSCRIBITION':
      updateAllTabs();
      newState.subs = action.subs;
      return newState;
    case 'RECEIVE_MARKETING':
      newState.marketing = action.marketing;
      return newState;
    case 'CHANGE_LANG':
      newState.language = action.lang;
      return newState;
    case 'RECEIVE_AVATAR': //20
      newState.avatar = action.avatar;
      return newState;
    case 'RECEIVE_CHILDREN':
      newState.children = action.children;
      return newState;
    default:
      return state;
  }
}

function auth(
  state = {
    user: false,
    reset: {
      result: false,
    },
    payments: [],
    plans: [],
    lessons: [],
    hasPassword: undefined,
  },
  action
) {
  switch (action.type) {
    case 'RECEIVE_AUTH':
      if (action.user) {
        setTimeZone(action.user.timezone);
        initCarrotQuest(action.user);
        trackYandexParams({ user_id: user._id });

        if (process.env.NODE_ENV === 'development') {
          window.localStorage.setItem(
            'authState',
            JSON.stringify({
              auth: {
                cached: true,
                user: { ...action.user },
              },
            })
          );
        }
      }
      return {
        ...state,
        user: action.user,
      };
    case 'UPDATE_AUTH':
      if (action.user) {
        setTimeZone(action.user.timezone);
        if (process.env.NODE_ENV === 'development') {
          window.localStorage.setItem(
            'authState',
            JSON.stringify({
              auth: {
                cached: true,
                user: { ...action.user },
              },
            })
          );
        }
      }
      return {
        ...state,
        cached: false,
        user: action.user,
      };
    case 'RECEIVE_CHECK_PASSWORD':
      return { ...state, hasPassword: action.result };
    case 'RECEIVE_PAYMENTS':
      return {
        ...state,
        payments: action.payments,
        plans: action.plans,
        lessons: action.lessons,
      };
    case 'RECEIVE_RESET':
      return { ...state, reset: { ...state.reset, result: action.result } };
    case 'RECEIVE_LOGOUT':
      toast.dismiss();
      window.localStorage.removeItem('authState');

      return {
        ...state,
        user: false,
        reset: { ...state.reset, result: false },
      };
    case 'RECEIVE_TETHER':
    case 'RECEIVE_CONFIRM':
    case 'RECEIVE_CURRENT_COURSES':
    case 'RECEIVE_COMPLETE_TASKS':
    case 'RECEIVE_SUBSCRIBITION':
    case 'RECEIVE_AVATAR':
    case 'RECEIVE_CHILDREN':
      return { ...state, user: user(state.user, action) };
    default:
      return state;
  }
}

export default auth;
